import React from 'react';
import { Redirect } from 'react-router-dom';
import ModalFullscreen from '../ModalFullscreen';
import FeedbackHelpContainer from '../FeedbackHelpContainer';
import generateReportUrl from '../../utils/reports/generateReportUrl';
import ModalFullscreenStore from '../../flux/ModalFullscreenStore';
import { feedbackCommonProperties } from '../../flux/ModalFullscreenActions';
import formatUsername from '../../utils/reports/formatUsername';

export default function StoreReportProblem({
  data,
  match,
  location,
}) {
  const redirectBackUrl = generateReportUrl(match.params.collectionType, match.params);
  const usernamesParameter = new URLSearchParams(location.search).get('usernames');

  if (usernamesParameter === null) {
    return (
      <Redirect to={redirectBackUrl} />
    );
  }

  const usernames = usernamesParameter.split(',');

  if (usernames.length === 0) {
    return (
      <Redirect to={redirectBackUrl} />
    );
  }

  const storeUsers = data.filter(row => (
    row.store_id === match.params.store &&
    row.country === match.params.country &&
    row.region_code === match.params.region
  ));

  const userSelection = storeUsers.filter(user => (
    usernames.some(username => username === user.username)
  ));

  const saBoutique = userSelection.length > 1 ? null : userSelection[0].store_thron_name;
  const saUsername = userSelection.map(user => formatUsername(user)).join(', ');

  return (
    <ModalFullscreen
      isOpen={true}
      isLoading={false}
    >
      <FeedbackHelpContainer>
        <iframe
          title="report-problem-modal"
          src={ModalFullscreenStore.getModalReportProblemUserUrl({ ...feedbackCommonProperties(), saBoutique, saUsername })}
          frameBorder="0"
          style={{ fontSize: 0 }}
        />
      </FeedbackHelpContainer>
    </ModalFullscreen>
  )
}
